import { useEffect, useRef, useState } from 'react';
export const usePromptsHeight = isHoverActive => {
  const [height, setHeight] = useState(0);
  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current) return;
    const resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        const newHeight = isHoverActive ? entry.contentRect.height : 0;
        setHeight(newHeight);
      }
    });
    resizeObserver.observe(ref.current);
    if (isHoverActive && ref.current) {
      setHeight(ref.current.getBoundingClientRect().height);
    } else {
      setHeight(0);
    }
    return () => resizeObserver.disconnect();
  }, [isHoverActive]);
  return {
    height,
    ref
  };
};